import React from "react";
import { Checkbox, FormControlLabel, Typography, IconButton } from "@material-ui/core";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import EditIcon from "@material-ui/icons/Edit";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useStyles } from "../../../../../../../components/common/PL/Cards/AccessTypeResultCard/AccessTypeResultCardStyles";

type ExistingVehicleCardProps = {
  plate: string;
  brand: string;
  model: string;
  color: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onEdit?: () => void;
  disabled?: boolean;
};

const ExistingVehicleCard: React.FC<ExistingVehicleCardProps> = ({
  plate,
  brand,
  model,
  color,
  checked,
  onCheckedChange,
  onEdit,
  disabled = false,
}) => {
  const classes = useStyles({});

  const details = [brand, model, color].filter(Boolean).join(" - ");

  return (
    <div className={classes.container} style={{ marginBottom: "16px" }}>
      <div className={classes.headerRow}>
        <div className={classes.left}>
          <FormControlLabel
            disabled={disabled}
            control={
              <Checkbox
                disabled={disabled}
                checked={checked}
                onChange={(e) => onCheckedChange(e.target.checked)}
                className={classes.checkbox}
                icon={<CheckBoxOutlineBlankIcon className={classes.checkboxIcon} />}
                checkedIcon={
                  <div className={classes.checkedIconWrapper}>
                    <CheckBoxIcon className={classes.checkboxIcon} />
                    <div className={classes.tickBackground} />
                  </div>
                }
              />
            }
            label={
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h6" className={classes.companyName}>
                  {plate}
                </Typography>
                {details && (
                  <Typography variant="body2" style={{ color: "#5B5D66", fontSize: "16px" }}>
                    {details}
                  </Typography>
                )}
              </div>
            }
            className={classes.personControl}
          />
        </div>
        <div
          className={classes.detailsSection}
          style={{ justifyContent: "flex-end", alignItems: "center", gap: "8px" }}
        >
          {onEdit && !disabled && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
              style={{ color: "#5B5D66" }}
              aria-label="Editar vehículo"
            >
              <EditIcon />
            </IconButton>
          )}
          <DriveEtaIcon className={classes.detailIcon} />
        </div>
      </div>
    </div>
  );
};

export default ExistingVehicleCard;
